<template>
  <div class="engraving-menu left-sidebar">
    <div class="menu-items">
      <div
        v-if="showEngravingText"
        class="menu-item"
      >
        <div class="wrapper-img">
          <div class="img">
            <img
              src="/images/icons/icon-graver-text.svg"
              alt=""
            />
          </div>
        </div>
        <div class="button-hover">
          <button @click="engravingTextPanel=true">
            <span class="button-wrapper-img">
              <span class="img"><img
                  src="/images/icons/icon-graver-text.svg"
                  alt=""
                /></span>
            </span>
            <span class="txt">Надписи</span>
          </button>
        </div>
      </div>
      <div
        class="menu-item"
        v-for="(menuItem, ndx) in menuItems"
        :key="`mt-${ndx}`"
      >
        <div class="wrapper-img">
          <div class="img">
            <img
              :src="`/images/client/sidebar/${menuItem.slug}.svg`"
              alt=""
            />
          </div>
        </div>
        <div class="button-hover">
          <button @click="elementsEngraving=menuItem">
            <span class="button-wrapper-img">
              <span class="img"><img
                  :src="`/images/client/sidebar/${menuItem.slug}.svg`"
                  alt=""
                /></span>
            </span>
            <span class="txt">{{ menuItem.name }}</span>
          </button>
        </div>
      </div>
    </div>
    <transition name="fade">
      <ElementsEngraving
        v-if="engravingTextPanel"
        @close="engravingTextPanel=false"
      >
        <template #header>
          Надписи
        </template>
        <template #content>
          <TextPanel />
        </template>
      </ElementsEngraving>
    </transition>
    <transition name="fade">
      <ElementsEngraving
        v-if="elementsEngraving"
        @close="elementsEngraving=null"
      >
        <template #header>
          {{ elementsEngraving.name }}
        </template>
        <template #content>
          <div class="engraving-group-types">
            <div
              class="engraving-group-type"
              v-for="type in elementsEngraving.types"
              :key="`engraving-type-${type.type_id}`"
            >
              <button
                class="focus:outline-none"
                @click="setChooseEngravings(elementsEngraving.element_group_id,type)"
              >
                <span
                  class="engraving-type__image"
                  :style="{backgroundImage: `url('${type.image}')`}"
                ></span>
                <span class="engraving-type__name">{{ type.name }}</span>
              </button>
            </div>
          </div>
        </template>
      </ElementsEngraving>
    </transition>
    <ClientModal
      v-if="chooseEngravings"
      @close-modal="clearChooseEngraving"
      @mountedModal="setLoadingObserver"
    >
      <template #header>
        <div class="text-xl mb-0">{{ chooseEngravings.name }}</div>
      </template>

      <div class="choose-engravings-list">

        <button
          class="choose-engravings-item rounded"
          v-for="element in chooseEngravings.elements"
          :key="`engraving-element-${element.element_id}`"
          @click="onChooseEngraving(element)"
        >
          <span class="choose-engravings__image-wrapper rounded">
            <span
              class="choose-engravings__image"
              :style="{ backgroundImage: `url(${element.image})` }"
            >
            </span>
          </span>
          <span class="text-sm font-bold uppercase mb-1">{{
              element.name
            }}</span>

          <span
            class="size-info"
            v-if="element.sizes&&element.sizes.length ==1"
          >
            <span>{{$t('main.ot')}}</span>
            <span>
              {{ element.sizes[0].width }}x{{ element.sizes[0].height }}
              -
              <span>{{ $toCurrency(element.sizes[0].price) }}</span>/<span v-html="$t('main.kv_sm')"></span>
            </span>
          </span>
          <span
            class="size-info"
            v-if="element.sizes&&element.sizes.length>1"
          >
            {{ element.sizes[0].width }}x{{ element.sizes[0].height }}
            ~ {{ element.sizes[element.sizes.length - 1].width }}x{{ element.sizes[element.sizes.length - 1].height }}
            -
            <span>{{ $toCurrency(element.sizes[0].price) }}</span>/<span v-html="$t('main.kv_sm')"></span>
          </span>

        </button>

        <Loading
          class="mt-2 ml-2"
          v-if="chooseEngravings.type.meta&&chooseEngravings.type.meta.current_page<chooseEngravings.type.meta.last_page"
          :ref="`elements__loader-${chooseEngravings.type.type_id}`"
          :id="`elements__loader-${chooseEngravings.type.type_id}`"
        ></Loading>
      </div>
    </ClientModal>
  </div>
</template>
<script>
import ElementsEngraving from "./Engravings/ElementsEngraving.vue";
import TextPanel from "./EngravingText/TextPanel.vue";
export default {
  components: { ElementsEngraving, TextPanel },
  name: "SidebarEngraving",
  data() {
    return {
      elementsEngraving: null,
      engravingTextPanel: false,
      chooseEngravings: null,
    };
  },
  methods: {
    onChooseEngraving(element) {
      this.$store.dispatch("clientOrder/selectEngraving", element);
      this.$store.dispatch("ClientEngravingSettings/setItem", element);
      this.clearChooseEngraving();
    },
    async setChooseEngravings(elementGroupId, type) {
      const elements = await this.$store.dispatch(
        "clientEngravings/getElementsByType",
        {
          elementGroupId,
          typeId: type.type_id,
        }
      );
      this.chooseEngravings = {
        name: type.name,
        type_id: type.type_id,
        element_group_id: elementGroupId,
        type,
        elements,
      };
    },
    clearChooseEngraving() {
      this.$store.dispatch("clientEngravings/clearElementsByType", {
        elementGroupId: this.chooseEngravings.element_group_id,
        typeId: this.chooseEngravings.type_id,
      });
      this.chooseEngravings = null;
    },
    setLoadingObserver() {
      const element = document.getElementById(
        `elements__loader-${this.chooseEngravings.type_id}`
      );
      if (element) {
        const loadingObserver = new IntersectionObserver(
          async (entries) => {
            entries.forEach(async (entry) => {
              if (entry.isIntersecting) {
                const elements = await this.$store.dispatch(
                  "clientEngravings/getElementsByType",
                  {
                    elementGroupId: this.chooseEngravings.element_group_id,
                    typeId: this.chooseEngravings.type_id,
                  }
                );
                elements.forEach((el) => {
                  this.chooseEngravings.elements.push(el);
                });
              }
            });
          },
          {
            threshold: 0.5,
          }
        );
        loadingObserver.observe(element);
      }
    },
  },
  computed: {
    menuItems() {
      return this.$store.state.clientEngravings.engravings;
    },
    showEngravingText() {
      const settings = this.$store.state.settings.settings || {};
      const useEngraving = settings.use_engraving;
      if (
        useEngraving === 0 ||
        useEngraving === false ||
        useEngraving === "0" ||
        useEngraving === "false"
      ) {
        return false;
      }

      const catalog = settings.engravings_catalog;
      if (!Array.isArray(catalog) || catalog.length === 0) {
        return true;
      }

      return catalog.some((item) => {
        if (typeof item === "string") return item === "eng_text";
        if (item && typeof item === "object") return item.code === "eng_text";
        return false;
      });
    },
  },
};
</script>
<style scoped>
.engraving-menu {
  position: relative;
  z-index: 2;
  background-color: #fff;
}
.engraving-group-types {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 15px;
}
.engraving-type__image {
  display: block;
  width: 70px;
  margin: auto;
  height: 85px;
  background: no-repeat;
  background-position: center center;
  background-size: contain;
}
.engraving-type__name {
  margin-top: 10px;
  text-align: center;
}
.choose-engravings-list {
  display: grid;
  column-gap: 1.85rem;
  row-gap: 0.75rem;
  grid-template-columns: repeat(4, 156px);
  align-items: flex-start;
}
.choose-engravings-item > span {
  display: block;
}
.choose-engravings-item {
  text-align: center;
  outline: none;
  padding: 2px;
  border: 1px transparent solid;
}
.choose-engravings-item:focus {
  border-color: #25a24c;
}
.choose-engravings__image-wrapper {
  background-color: #000;
  margin-bottom: 0.35rem;
  height: 150px;
  width: 150px;
  padding: 5px;
}
.choose-engravings__image {
  height: 100%;
  width: 100%;
  display: flex;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: contain;
}

.size-info {
  font-size: 13px;
}

@media screen and (max-width: 1000px) {
  .choose-engravings-list {
    grid-template-columns: repeat(2, 1fr);
  }
  .choose-engravings__image-wrapper {
    margin: 0 auto 10px auto;
  }
}
</style>
